<div class="cart-btn notification-btn p-relative" #notificationContainer>
  <a 
    href="javascript:void(0)" 
    class="text-light-green fw-700"
    #notificationLink
    (click)="toggleDropdown($event)"
    (touchend)="toggleDropdown($event); $event.preventDefault()"
    style="cursor: pointer; touch-action: manipulation; display: inline-flex; align-items: center; justify-content: center; min-height: 44px; min-width: 44px; position: relative;"
    title="Notifications"
  >
    <i class="fas fa-bell"></i>
    <span class="user-alert-notification" *ngIf="unreadCount > 0">
      {{ unreadCount > 9 ? '9+' : unreadCount }}
    </span>
  </a>
  <div 
    class="notification-dropdown"
    [class.show]="showDropdown"
    (click)="$event.stopPropagation()"
  >
    <!-- Notification Header -->
    <div class="notification-header" style="padding: 15px; border-bottom: 1px solid #e0e0e0;">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <h6 style="margin: 0; font-weight: 600; color: #333;">Notifications</h6>
        <button
          *ngIf="unreadCount > 0"
          type="button"
          (click)="markAllAsRead()"
          [disabled]="isLoading"
          style="
            background: none;
            border: none;
            color: hsl(0.41deg, 75.51%, 38.43%);
            cursor: pointer;
            font-size: 12px;
            padding: 4px 8px;
            min-height: 32px;
            touch-action: manipulation;
          "
          title="Mark all as read"
        >
          Mark all read
        </button>
      </div>
    </div>

    <!-- Notification Tabs -->
    <div class="notification-tabs">
      <button
        type="button"
        class="tab-button"
        [class.active]="activeTab === 'unread'"
        (click)="setActiveTab('unread')"
        (touchend)="setActiveTab('unread'); $event.preventDefault()"
        style="touch-action: manipulation; min-height: 44px;"
      >
        Unread
        <span class="badge badge-sm" *ngIf="getUnreadNotifications().length > 0" style="margin-left: 6px;">
          {{ getUnreadNotifications().length }}
        </span>
      </button>
      <button
        type="button"
        class="tab-button"
        [class.active]="activeTab === 'read'"
        (click)="setActiveTab('read')"
        (touchend)="setActiveTab('read'); $event.preventDefault()"
        style="touch-action: manipulation; min-height: 44px;"
      >
        Read
      </button>
    </div>

    <!-- Notification List -->
    <div class="notification-list" style="max-height: 400px; overflow-y: auto;">
      <!-- Loading State -->
      <div *ngIf="isLoading" class="text-center" style="padding: 40px;">
        <div class="spinner-border spinner-border-sm text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <!-- Unread Tab -->
      <div *ngIf="!isLoading && activeTab === 'unread'">
        <!-- Today's Unread Notifications -->
        <div *ngIf="getTodayNotifications(getUnreadNotifications()).length > 0">
          <div class="notification-section-header">Today</div>
          <div
            *ngFor="let notification of getTodayNotifications(getUnreadNotifications()); trackBy: trackByNotificationId"
            class="notification-item unread"
            [class.actionable]="isActionableReminder(notification)"
            (click)="onNotificationClick(notification)"
            (touchend)="onNotificationClick(notification); $event.preventDefault()"
            style="touch-action: manipulation; min-height: 44px;"
          >
            <div class="notification-content">
              <div class="notification-icon" [ngClass]="getNotificationColor(notification.type)">
                <i [class]="getNotificationIcon(notification.type)"></i>
              </div>
              <div class="notification-body">
                <div class="notification-title">{{ getNotificationTitle(notification) }}</div>
                <div class="notification-message">{{ getNotificationMessage(notification) }}</div>
                <div class="notification-time text-muted" style="font-size: 11px;">
                  {{ formatTime(notification.createdTime) }}
                </div>
                <!-- Actionable Reminder Actions -->
                <div *ngIf="isActionableReminder(notification)" class="notification-actions">
                  <button
                    type="button"
                    class="btn btn-sm btn-success"
                    (click)="confirmAppointment(notification, $event)"
                    [disabled]="isLoading"
                    style="margin-top: 8px; min-height: 32px; touch-action: manipulation;"
                  >
                    <i class="fas fa-check"></i> Confirm
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-danger"
                    (click)="cancelAppointment(notification, $event)"
                    [disabled]="isLoading"
                    style="margin-top: 4px; min-height: 32px; touch-action: manipulation;"
                  >
                    <i class="fas fa-times"></i> Cancel
                  </button>
                </div>
              </div>
              <div class="notification-status">
                <span class="unread-indicator" *ngIf="!notification.read"></span>
              </div>
            </div>
          </div>
        </div>

        <!-- Previous Unread Notifications -->
        <div *ngIf="getPreviousNotifications(getUnreadNotifications()).length > 0">
          <div class="notification-section-header">Earlier</div>
          <div
            *ngFor="let notification of getPreviousNotifications(getUnreadNotifications()); trackBy: trackByNotificationId"
            class="notification-item unread"
            [class.actionable]="isActionableReminder(notification)"
            (click)="onNotificationClick(notification)"
            (touchend)="onNotificationClick(notification); $event.preventDefault()"
            style="touch-action: manipulation; min-height: 44px;"
          >
            <div class="notification-content">
              <div class="notification-icon" [ngClass]="getNotificationColor(notification.type)">
                <i [class]="getNotificationIcon(notification.type)"></i>
              </div>
              <div class="notification-body">
                <div class="notification-title">{{ getNotificationTitle(notification) }}</div>
                <div class="notification-message">{{ getNotificationMessage(notification) }}</div>
                <div class="notification-time text-muted" style="font-size: 11px;">
                  {{ formatTime(notification.createdTime) }}
                </div>
                <!-- Actionable Reminder Actions -->
                <div *ngIf="isActionableReminder(notification)" class="notification-actions">
                  <button
                    type="button"
                    class="btn btn-sm btn-success"
                    (click)="confirmAppointment(notification, $event)"
                    [disabled]="isLoading"
                    style="margin-top: 8px; min-height: 32px; touch-action: manipulation;"
                  >
                    <i class="fas fa-check"></i> Confirm
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-danger"
                    (click)="cancelAppointment(notification, $event)"
                    [disabled]="isLoading"
                    style="margin-top: 4px; min-height: 32px; touch-action: manipulation;"
                  >
                    <i class="fas fa-times"></i> Cancel
                  </button>
                </div>
              </div>
              <div class="notification-status">
                <span class="unread-indicator" *ngIf="!notification.read"></span>
              </div>
            </div>
          </div>
        </div>

        <!-- Empty State for Unread -->
        <div *ngIf="getUnreadNotifications().length === 0" class="empty-notifications text-center">
          <p style="color: #666; margin: 0;">No unread notifications</p>
        </div>
      </div>

      <!-- Read Tab -->
      <div *ngIf="!isLoading && activeTab === 'read'">
        <!-- Today's Read Notifications -->
        <div *ngIf="getTodayNotifications(getReadNotifications()).length > 0">
          <div class="notification-section-header">Today</div>
          <div
            *ngFor="let notification of getTodayNotifications(getReadNotifications()); trackBy: trackByNotificationId"
            class="notification-item"
            (click)="onNotificationClick(notification)"
            (touchend)="onNotificationClick(notification); $event.preventDefault()"
            style="touch-action: manipulation; min-height: 44px;"
          >
            <div class="notification-content">
              <div class="notification-icon" [ngClass]="getNotificationColor(notification.type)">
                <i [class]="getNotificationIcon(notification.type)"></i>
              </div>
              <div class="notification-body">
                <div class="notification-title">{{ getNotificationTitle(notification) }}</div>
                <div class="notification-message">{{ getNotificationMessage(notification) }}</div>
                <div class="notification-time text-muted" style="font-size: 11px;">
                  {{ formatTime(notification.createdTime) }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Previous Read Notifications -->
        <div *ngIf="getPreviousNotifications(getReadNotifications()).length > 0">
          <div class="notification-section-header">Earlier</div>
          <div
            *ngFor="let notification of getPreviousNotifications(getReadNotifications()); trackBy: trackByNotificationId"
            class="notification-item"
            (click)="onNotificationClick(notification)"
            (touchend)="onNotificationClick(notification); $event.preventDefault()"
            style="touch-action: manipulation; min-height: 44px;"
          >
            <div class="notification-content">
              <div class="notification-icon" [ngClass]="getNotificationColor(notification.type)">
                <i [class]="getNotificationIcon(notification.type)"></i>
              </div>
              <div class="notification-body">
                <div class="notification-title">{{ getNotificationTitle(notification) }}</div>
                <div class="notification-message">{{ getNotificationMessage(notification) }}</div>
                <div class="notification-time text-muted" style="font-size: 11px;">
                  {{ formatTime(notification.createdTime) }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Empty State for Read -->
        <div *ngIf="getReadNotifications().length === 0" class="empty-notifications text-center">
          <p style="color: #666; margin: 0;">No read notifications</p>
        </div>
      </div>

      <!-- Empty State (No notifications at all) -->
      <div *ngIf="!isLoading && filteredNotifications.length === 0" class="empty-notifications text-center">
        <p style="color: #666; margin: 0;">No notifications</p>
      </div>
    </div>

    <!-- Notification Footer -->
    <div class="notification-footer" style="padding: 10px 15px; border-top: 1px solid #e0e0e0; text-align: center;">
      <a
        href="javascript:void(0)"
        (click)="viewAllNotifications()"
        (touchend)="viewAllNotifications(); $event.preventDefault()"
        style="
          color: hsl(0.41deg, 75.51%, 38.43%);
          text-decoration: none;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          touch-action: manipulation;
          min-height: 44px;
          display: inline-flex;
          align-items: center;
        "
      >
        View all notifications
      </a>
    </div>
  </div>
</div>
